import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { EntityConfig } from '../_appCommon/base/EntityConfig';
import { EntityDataServiceBase } from '../_appCommon/base/EntityDataServiceBase';
import { UrlQueryDef } from '../_appCommon/base/UrlQueryDef';

@Injectable()
export class PrescriptionDataService extends EntityDataServiceBase
{
  constructor(protected http: HttpClient)
  {
    super(http, 'prescription');
  }

  protected loadEntityConfig(): void
  {
    this.entityConfig = new EntityConfig();

    this.entityConfig.entityDisplayName = 'prescription';
    this.entityConfig.apiUrl = 'api/Prescription';
  }

  public updatePrescriptionStep(setupId: number, stepNumber:number, stepForm: any, caseId:number = 0)
  {
    let queryDef = new UrlQueryDef();
    stepForm["setupId"] = setupId;
    if(stepNumber == 9) { stepForm["caseId"] = caseId;}
    let observable = this.http.put(this.createUrl(`setup/${setupId}/prescription/step${stepNumber}`), stepForm, queryDef.getRequestConfig(true)).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }

  public generatePDF(prescriptionId: number,caseId:Number): Observable<any>
  {
    let queryDef = new UrlQueryDef();

    let body = {Id:prescriptionId,CaseId:caseId};

    let observable = this.http.post(this.createUrl(`generatePDF`), body, queryDef.getRequestConfig(true)).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }

  public getPrescriptionsByCaseId(caseId: number): Observable<any>
  {
    let queryDef = new UrlQueryDef();

    let body = { caseId: caseId };

    let observable = this.http.post(this.createUrl(`getPrescriptionsByCaseId`), body, queryDef.getRequestConfig(true)).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }

  public getPrescriptionByStep(setupId: number, stepNumber:number, prescriptionId: number)
  {
    let queryDef = new UrlQueryDef();

    let observable = this.http.get(this.createUrl(`setup/${setupId}/prescription/${prescriptionId}/step${stepNumber}`), queryDef.getRequestConfig(true)).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }

  
  public updatePrescriptionFileBySetupId(setupId: number, blobId : number){
    let queryDef = new UrlQueryDef();
    let body = { setupId: setupId, blobId: blobId };
    let observable = this.http.put(this.createUrl(`updatePrescriptionFileBySetupId`), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public deleteFilePrescriptionById(caseId: number, stageNumber: number): Observable<any>{
    let queryDef = new UrlQueryDef();
    let body = { caseId: caseId, stageNumber: stageNumber };
    let observable = this.http.put(this.createUrl(`deleteFile`), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }
}

